import { Pipe, PipeTransform } from "@angular/core";
import { DateUtilsService } from "@dmms/shared/utils/services";

@Pipe({
  name: "setLocalUTC",
  standalone: true,
})
export class SetLocalUTCPipe implements PipeTransform {
  transform(value: Date | string | null): Date | null {
    if (value === null) return null;
    const stringDate = typeof value === "string" ? value : value.toISOString();
    return new Date(DateUtilsService.getFullLocaleDate(stringDate));
  }
}
